import { ArrowTrendingUpIcon } from '@heroicons/react/24/solid';
import RenderVideo from './RenderVideo';
import { videoSources } from '../utils/State';

const Armorvideotech = ({ formRef }) => {

    const youtubeUrl = 'https://youtube.com/embed/UhFGJ8aYyFc';
    const r2Url = null;

    const scrolltoForm = (e) => {
        // Preventing the default behavior of the form submit (which is to refresh the page)
        e.preventDefault();
        if (formRef && formRef.current) {
            formRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };
    return (
        <div className="bg-green-50 p-4 mb-8">
            <div className="flex flex-col md:flex-row items-center md:items-center justify-between">
                {/* Left Column: Text and Button */}
                <div className="md:w-1/2 flex flex-col justify-start items-start text-left md:text-left mb-4 md:mb-0">
                    <p className="mt-6 mx-8 text-gray-600 text-2xl sm:text-xl">
                        <span className="font-bold">Armor-Crete®</span> is a family of polymer modified coatings designed to resurface existing concrete and transform it into a durable, decorative, attractive surface.
                    </p>
                    <p className="mt-6 mx-8 text-gray-600 text-2xl sm:text-xl">
                    The most common applications for concrete resurfacing are driveways, patios, walkways, swimming pool decks and garage floors. 
                    Armor-Crete® products is sprayed with a texture gun.
                    </p>
                    <p className="mt-6 mx-8 text-gray-600 text-2xl sm:text-xl">
                    Armor-Crete® products come with a 5 - 10 year warranty.
                    </p>
                    <button
                        onClick={scrolltoForm}
                        className="min-w-[13rem] w-52 rounded-md bg-green-700 px-4 py-2 text-lg font-semibold text-white shadow-sm hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-700 focus:ring-offset-2 mt-4 mx-8"
                    >
                        Get a Free Estimate
                    </button>
                </div>

                {/* Right Column: Video */}
                <div className="md:w-1/2 flex flex-col justify-center">
                    <div className="flex items-center justify-center mt-4 md:mt-0">
                        <ArrowTrendingUpIcon
                            className="h-12 w-12 text-green-700"
                            style={{ transform: 'scaleX(-1) scaleY(-1)' }}
                        />
                        <p className="mt-1 text-gray-600 text-center mr-2">
                            Watch a short video to see how it all works!
                        </p>
                    </div>

                    <div className="video-container mt-4" style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
                        <RenderVideo youtube={videoSources.armorCreteYoutube} r2={videoSources.armorCreteProcess} />
                    </div>
                </div>
            </div>
        </div>



    );


}
export default Armorvideotech;